/*getting-started*/
/*defining-tasks*/
/*running-tasks-in-the-right-order*/
/*depending-on-tasks-in-dependencies-with-*/
/*depending-on-tasks-in-the-same-package*/
/*depending-on-a-specific-task-in-a-specific-package*/
/*no-dependencies*/
/*specifying-outputs*/
/*specifying-inputs*/
/*restoring-defaults-with-turbodefault*/
/*registering-root-tasks*/
/*when-to-use-root-tasks*/
/*advanced-use-cases*/
/*using-package-configurations*/
/*composing-configurations*/
/*long-running-tasks-with-runtime-dependencies*/
/*performing-side-effects*/
/*dependent-tasks-that-can-be-run-in-parallel*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "配置任务",
  "description": "了解如何描述存储库中的工作流程，以便尽快完成它们。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "任务是 Turborepo 运行的脚本。你可以表达 turbo.json configuration 和 软件包图表 中任务之间的关系。"
  }, {
    "heading": "",
    "content": "¥A task is a script that Turborepo runs. You can express relationships between tasks in your turbo.json configuration and Package Graph."
  }, {
    "heading": "",
    "content": "Turborepo 始终会并行执行所有工作，以确保一切尽可能快地运行。这比一次运行一个任务要快，这也是 Turborepo 如此快速的原因之一。"
  }, {
    "heading": "",
    "content": "¥Turborepo will always parallelize any work that it can to ensure everything runs as fast as possible. This is faster than running tasks one at a time, and it's a part of what makes Turborepo so fast."
  }, {
    "heading": "",
    "content": "例如，yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test 如下所示："
  }, {
    "heading": "",
    "content": "¥For example, yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test would look like this:"
  }, {
    "heading": "",
    "content": "但是，为了使用 Turborepo 更快地完成相同的工作，你可以使用 turbo run lint build test："
  }, {
    "heading": "",
    "content": "¥But, to get the same work done faster with Turborepo, you can use turbo run lint build test:"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Getting started"
  }, {
    "heading": "入门-getting-started",
    "content": "根 turbo.json 文件是注册 Turborepo 将运行的任务的地方。定义好任务后，你就可以使用 turbo run 运行一个或多个任务。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥The root turbo.json file is where you'll register the tasks that Turborepo will run. Once you have your tasks defined, you'll be able to run one or more tasks using turbo run."
  }, {
    "heading": "入门-getting-started",
    "content": "如果你是新手，我们建议你使用 使用 create-turbo 创建新仓库 并编辑 turbo.json 文件以尝试本指南中的代码片段。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥If you're starting fresh, we recommend creating a new repository using create-turbo and editing the turbo.json file to try out the snippets in this guide."
  }, {
    "heading": "入门-getting-started",
    "content": "如果你要在现有存储库中采用 Turborepo，请在存储库的根目录中创建一个 turbo.json 文件。你将使用它来了解本指南中的其余配置选项。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥If you're adopting Turborepo in an existing repository, create a turbo.json file in the root of your repository. You'll be using it to learn about the rest of the configuration options in this guide."
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "¥Defining tasks"
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "tasks 对象中的每个键都是一个可由 turbo run 执行的任务。Turborepo 将在你的包中搜索其 package.json 中与任务同名的脚本。"
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "¥Each key in the tasks object is a task that can be executed by turbo run. Turborepo will search your packages for scripts in their package.json that have the same name as the task."
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "要定义任务，请在 turbo.json 中使用 tasks 对象。例如，一个名为 build 且没有依赖和输出的基本任务可能如下所示："
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "¥To define a task, use the tasks object in turbo.json. For example, a basic task with no dependencies and no outputs named build might look like this:"
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "如果你此时运行 turbo run build，Turborepo 将并行运行你软件包中的所有 build 脚本，并且不会缓存任何文件输出。这将很快导致错误。你缺少一些重要的部分，无法使其按预期工作。"
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "¥If you run turbo run build at this point, Turborepo will run all build scripts in your packages in parallel and won't cache any file outputs. This will quickly lead to errors. You're missing a few important pieces to make this work how you'd expect."
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "¥Running tasks in the right order"
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "dependsOn 键 用于指定在其他任务开始运行之前必须完成的任务。例如，在大多数情况下，你希望库的 build 脚本在应用的 build 脚本运行之前完成。为此，你需要使用以下 turbo.json："
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "¥The dependsOn key is used to specify the tasks that must complete before a different task begins running. For example, in most cases, you want the build script for your libraries to complete before your application's build script runs. To do this, you'd use the following turbo.json:"
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "现在，你已拥有预期的构建顺序，即先构建依赖，再构建依赖。"
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "¥You now have the build order you would expect, building dependencies before dependents."
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "但要小心。目前，你尚未将构建输出标记为缓存。为此，请跳转到 指定输出 部分。"
  }, {
    "heading": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "¥But be careful. At this point, you haven't marked the build outputs for caching. To do so, jump to the Specifying outputs section."
  }, {
    "heading": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "¥Depending on tasks in dependencies with ^"
  }, {
    "heading": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "^ 微语法指示 Turborepo 在目标包之前运行直接依赖中的任务。如果你的应用依赖于名为 ui 的库，并且该库包含 build 任务，则 ui 中的 build 脚本将首先运行。成功完成后，应用中的 build 任务将运行。"
  }, {
    "heading": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "¥The ^ microsyntax tells Turborepo to run the task in direct dependencies before the target package. If your application depends on a library named ui and the library has a build task, the build script in ui will run first. Once it has successfully completed, the build task in your application will run."
  }, {
    "heading": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "这是一个重要的模式，因为它可以确保应用的 build 任务拥有编译所需的所有必要依赖。当你的依赖图发展到具有多层任务依赖的更复杂结构时，此概念也适用。"
  }, {
    "heading": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "¥This is an important pattern as it ensures that your application's build task will have all of the necessary dependencies that it needs to compile. This concept also applies as your dependency graph grows to a more complex structure with many levels of task dependencies."
  }, {
    "heading": "依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
    "content": "¥Depending on tasks in the same package"
  }, {
    "heading": "依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
    "content": "有时，你可能需要确保同一个软件包中的两个任务按特定顺序运行。例如，你可能需要先在库中运行 build 任务，然后再在同一个库中运行 test 任务。为此，请将 dependsOn 键中的脚本指定为纯字符串（不带 ^）。"
  }, {
    "heading": "依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
    "content": "¥Sometimes, you may need to ensure that two tasks in the same package run in a specific order. For example, you may need to run a build task in your library before running a test task in the same library. To do this, specify the script in the dependsOn key as a plain string (without the ^)."
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "¥Depending on a specific task in a specific package"
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "你还可以指定特定包中要依赖的单个任务。在下面的示例中，utils 中的 build 任务必须在任何 lint 任务之前运行。"
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "¥You can also specify an individual task in a specific package to depend on. In the example below, the build task in utils must be run before any lint tasks."
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "你还可以更具体地指定依赖任务，将其限制在某个软件包上："
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "¥You can also be more specific about the dependent task, limiting it to a certain package:"
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "使用此配置，你的 web 包中的 lint 任务只能在 utils 包中的 build 任务完成后运行。"
  }, {
    "heading": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "¥With this configuration, the lint task in your web package can only be run after the build task in the utils package is complete."
  }, {
    "heading": "无依赖-no-dependencies",
    "content": "¥No dependencies"
  }, {
    "heading": "无依赖-no-dependencies",
    "content": "某些任务可能没有任何依赖。例如，用于在 Markdown 文件中查找拼写错误的任务可能不需要关心其他任务的状态。在这种情况下，你可以省略 dependsOn 键或提供一个空数组。"
  }, {
    "heading": "无依赖-no-dependencies",
    "content": "¥Some tasks may not have any dependencies. For example, a task for finding typos in Markdown files likely doesn't need to care about the status of your other tasks. In this case, you can omit the dependsOn key or provide an empty array."
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "¥Specifying outputs"
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "Turborepo 会缓存任务的输出，这样你就不会重复执行相同的工作。我们将在 缓存指南 中深入讨论这一点，但首先请确保你的任务已正确配置。"
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "¥Turborepo caches the outputs of your tasks so that you never do the same work\ntwice. We'll discuss this in depth in the Caching\nguide, but let's make sure your tasks\nare properly configured first."
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "outputs 键告知 Turborepo 在任务成功完成后应缓存的文件和目录。如果没有定义此键，Turborepo 将不会缓存任何文件。后续运行时命中缓存不会恢复任何文件输出。"
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "¥The outputs key tells Turborepo files and directories it should cache when the task has successfully completed. Without this key defined, Turborepo will not cache any files. Hitting cache on subsequent runs will not restore any file outputs."
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "以下是一些常用工具的输出示例："
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "¥Below are a few examples of outputs for common tools:"
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "Globs 是相对于包的，因此 dist/** 将分别处理每个包输出的 dist。关于如何为 outputs 键构建通配符模式的更多信息，请参阅 通配符规范。"
  }, {
    "heading": "指定-outputs-specifying-outputs",
    "content": "¥Globs are relative to the package, so dist/** will handle the dist that is outputted for each package, respectively. For more on building globbing patterns for the outputs key, see the globbing specification."
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥Specifying inputs"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "inputs 键用于指定要包含在 caching 任务哈希值中的文件。默认情况下，Turborepo 将包含包中所有由 Git 跟踪的文件。但是，你可以使用 inputs 键更具体地指定哈希中包含哪些文件。"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥The inputs key is used to specify the files that you want to include in the task's hash for caching. By default, Turborepo will include all files in the package that are tracked by Git. However, you can be more specific about which files are included in the hash using the inputs key."
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "例如，一个用于查找 Markdown 文件中拼写错误的任务可以这样定义："
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥As an example, a task for finding typos in Markdown files could be defined like this:"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "现在，只有 Markdown 文件中的更改才会导致 spell-check 任务丢失缓存。"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥Now, only changes in Markdown files will cause the spell-check task to miss cache."
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "此功能会退出 Turborepo 的所有默认 inputs 行为，包括跟随源代码管理跟踪的更改。这意味着你的 .gitignore 文件将不再被遵守，你需要确保不要用 glob 捕获这些文件。"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥This feature opts out of all of Turborepo's default inputs behavior, including following along with changes tracked by source control. This means that your .gitignore file will no longer be respected, and you will need to ensure that you do not capture those files with your globs."
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "要恢复默认行为，请使用 $TURBO_DEFAULT$ 微语法。"
  }, {
    "heading": "指定-inputs-specifying-inputs",
    "content": "¥To restore the default behavior, use the $TURBO_DEFAULT$ microsyntax."
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "¥Restoring defaults with $TURBO_DEFAULT$"
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "inputs 的默认行为 通常是你执行任务时所需要的。但是，你可以通过微调 inputs 键来忽略已知不会影响任务输出的文件更改，从而提高某些任务的缓存命中率。"
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "¥The default inputs behavior is often what you will want for your tasks. However, you can increase your cache hit ratios for certain tasks by fine-tuning your inputs to ignore changes to files that are known to not affect the task's output."
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "因此，你可以使用 $TURBO_DEFAULT$ 微语法来微调默认的 inputs 行为："
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "¥For this reason, you can use the $TURBO_DEFAULT$ microsyntax to fine-tune the default inputs behavior:"
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "在此任务定义中，Turborepo 将对 build 任务使用默认的 inputs 行为，但会忽略对 README.md 文件的更改。如果 README.md 文件发生更改，任务仍会命中缓存。"
  }, {
    "heading": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "¥In this task definition, Turborepo will use the default inputs behavior for the build task, but will ignore changes to the README.md file. If the README.md file is changed, the task will still hit cache."
  }, {
    "heading": "注册根任务-registering-root-tasks",
    "content": "¥Registering Root Tasks"
  }, {
    "heading": "注册根任务-registering-root-tasks",
    "content": "你还可以使用 turbo 在工作区根目录下的 package.json 中运行脚本。例如，除了每个包中的 lint 任务之外，你可能还想为工作区根目录中的文件运行 lint:root 任务："
  }, {
    "heading": "注册根任务-registering-root-tasks",
    "content": "¥You can also run scripts in the package.json in the Workspace root using turbo. For example, you may want to run a lint:root task for the files in your Workspace's root directory in addition to the lint task in each package:"
  }, {
    "heading": "注册根任务-registering-root-tasks",
    "content": "根任务现已注册，turbo run lint:root 现在将运行该任务。你还可以运行 turbo run lint lint:root 来运行所有 linting 任务。"
  }, {
    "heading": "注册根任务-registering-root-tasks",
    "content": "¥With the Root Task now registered, turbo run lint:root will now run the task. You can also run turbo run lint lint:root to run all your linting tasks."
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "¥When to use Root Tasks"
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "工作区根目录的 Linting 和格式化：你的工作区根目录中可能有需要进行 lint 和格式化的代码。例如，你可能想在根目录中运行 ESLint 或 Prettier。"
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "¥Linting and formatting of the Workspace root: You might have code in your Workspace root that you want to lint and format. For example, you might want to run ESLint or Prettier in your root directory."
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "增量迁移：在迁移到 Turborepo 时，你可能有一个中间步骤，其中有一些脚本尚未移动到包中。在这种情况下，你可以创建一个根任务来开始迁移，并稍后将任务分散到各个包。"
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "¥Incremental migration: While you're migrating to Turborepo, you might have an in-between step where you have some scripts that you haven't moved to packages yet. In this case, you can create a Root Task to start migrating and fan the tasks out to packages later."
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "不属于包范围的脚本：你可能有一些脚本在特定包的上下文中没有意义。这些脚本可以注册为根任务，因此你仍然可以使用 turbo 运行它们，以实现缓存、并行化和工作流目的。"
  }, {
    "heading": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "¥Scripts without a package scope: You may have some scripts that don't make sense in the context of specific packages. Those scripts can be registered as Root Tasks so you can still run them with turbo for caching, parallelization, and workflow purposes."
  }, {
    "heading": "高级用例-advanced-use-cases",
    "content": "¥Advanced use cases"
  }, {
    "heading": "使用软件包配置-using-package-configurations",
    "content": "¥Using Package Configurations"
  }, {
    "heading": "使用软件包配置-using-package-configurations",
    "content": "软件包配置 是直接放置在包中的 turbo.json 文件。这允许包为其自身任务定义特定行为，而不会影响仓库的其余部分。"
  }, {
    "heading": "使用软件包配置-using-package-configurations",
    "content": "¥Package Configurations are turbo.json files that are placed directly into a package. This allows a package to define specific behavior for its own tasks without affecting the rest of the repository."
  }, {
    "heading": "使用软件包配置-using-package-configurations",
    "content": "在拥有多个团队的大型单体仓库中，这可以让团队更好地控制自己的任务。要了解更多信息，请访问 包配置文档"
  }, {
    "heading": "使用软件包配置-using-package-configurations",
    "content": "¥In large monorepos with many teams, this allows teams greater control over their own tasks. To learn more, visit the Package Configurations documentation"
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "¥Composing configurations"
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "软件包配置 可以组合使用，以便在更少的配置下实现更强大的控制："
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "¥Package Configurations can be composed for greater control with less configuration:"
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "从其他包扩展：创建多个包可以继承的共享配置包，从而启用共享的 turbo.json 配置。"
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "¥Extending from other packages: Create shared configuration packages that multiple packages can extend from, enabling shared turbo.json configurations."
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "添加到扩展配置：使用 $TURBO_EXTENDS$ 微语法向继承的数组值（例如 outputs 和 env）添加内容而不是替换它们。"
  }, {
    "heading": "组合配置-composing-configurations",
    "content": "¥Adding to extended configurations: Use the $TURBO_EXTENDS$ microsyntax to add to inherited array values like outputs and env instead of replacing them."
  }, {
    "heading": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "¥Long-running tasks with runtime dependencies"
  }, {
    "heading": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "你可能有一个长时间运行的任务，需要另一个任务始终同时运行。为此，请使用 with 键。"
  }, {
    "heading": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "¥You might have a long-running task that requires another task to always be running at the same time. For this, use the with key."
  }, {
    "heading": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "长时间运行的任务永远不会退出，这意味着你不能依赖它。相反，每当 web#dev 任务运行时，with 关键字都会运行 api#dev 任务。"
  }, {
    "heading": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "¥A long-running task never exits, meaning you can't depend on it. Instead, the with keyword will run the api#dev task whenever the web#dev task runs."
  }, {
    "heading": "执行副作用-performing-side-effects",
    "content": "¥Performing side-effects"
  }, {
    "heading": "执行副作用-performing-side-effects",
    "content": "某些任务无论如何都应该始终运行，例如缓存构建后的部署脚本。对于这些任务，请将 \"cache\": false 添加到你的任务定义中。"
  }, {
    "heading": "执行副作用-performing-side-effects",
    "content": "¥Some tasks should always be run no matter what, like a deployment script after a cached build. For these tasks, add \"cache\": false to your task definition."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Dependent tasks that can be run in parallel"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "某些任务可以并行运行，尽管它们依赖于其他软件包。类型检查器就是符合此描述的任务示例，因为类型检查器无需等待依赖的输出即可成功运行。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Some tasks can be run in parallel despite being dependent on other packages. An example of tasks that fit this description are type checkers, since a type checker doesn't need to wait for outputs in dependencies to run successfully."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "因此，你可能倾向于像这样定义你的 check-types 任务："
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Because of this, you may be tempted to define your check-types task like this:"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "这会并行运行你的任务 - 但它不考虑依赖中的源代码更改。这意味着你可以："
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥This runs your tasks in parallel - but doesn't account for source code changes in dependencies. This means you can:"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "对你的 ui 软件包的界面进行重大更改。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Make a breaking change to the interface of your ui package."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "运行 turbo check-types，在依赖于 ui 的应用包中命中缓存。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Run turbo check-types, hitting cache in an application package that depends on ui."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "这是不正确的，因为尽管应用包未更新以使用新接口，但它仍会显示成功的缓存命中。在编辑器中手动检查应用包中的 TypeScript 错误可能会发现错误。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥This is incorrect, since the application package will show a successful cache hit, despite not being updated to use the new interface. Checking for TypeScript errors in your application package manually in your editor is likely to reveal errors."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "因此，你需要对 check-types 任务定义进行一些小改动："
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥Because of this, you make a small change to your check-types task definition:"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "如果你再次测试在 ui 软件包中进行重大更改，你会注意到缓存行为现在是正确的。但是，任务不再并行运行。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥If you test out making breaking changes in your ui package again, you'll notice that the caching behavior is now correct. However, tasks are no longer running in parallel."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "为了同时满足这两个要求（正确性和并行性），你可以将 传输节点 引入到你的任务图中："
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥To meet both requirements (correctness and parallelism), you can introduce Transit Nodes to your Task Graph:"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "这些 Transit 节点使用一个不执行任何操作的任务在包依赖之间建立关系，因为它与任何 package.json 中的脚本都不匹配。因此，你的任务可以并行运行，并能够感知其内部依赖的变化。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥These Transit Nodes create a relationship between your package dependencies using a task that doesn't do anything because it doesn't match a script in any package.jsons. Because of this, your tasks can run in parallel and be aware of changes to their internal dependencies."
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "在此示例中，我们使用了名称 transit - 但你可以将任务命名为工作区中尚未包含脚本的任何名称。"
  }, {
    "heading": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "¥In this example, we used the name transit - but you can name the task\nanything that isn't already a script in your Workspace."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "配置 turbo.json 文档 中还有更多选项，你将在接下来的指南中探索。现在，你可以开始运行一些任务来了解基本工作原理。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥There are more options available in the Configuring turbo.json documentation that you will explore in the coming guides. For now, you can start running a few tasks to see how the basics work."
  }],
  "headings": [{
    "id": "入门-getting-started",
    "content": "入门 /*getting-started*/"
  }, {
    "id": "定义任务-defining-tasks",
    "content": "定义任务 /*defining-tasks*/"
  }, {
    "id": "按正确顺序运行任务-running-tasks-in-the-right-order",
    "content": "按正确顺序运行任务 /*running-tasks-in-the-right-order*/"
  }, {
    "id": "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
    "content": "依赖于 ^ 依赖中的任务 /*depending-on-tasks-in-dependencies-with-*/"
  }, {
    "id": "依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
    "content": "依赖于同一包中的任务 /*depending-on-tasks-in-the-same-package*/"
  }, {
    "id": "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
    "content": "依赖于特定包中的特定任务 /*depending-on-a-specific-task-in-a-specific-package*/"
  }, {
    "id": "无依赖-no-dependencies",
    "content": "无依赖 /*no-dependencies*/"
  }, {
    "id": "指定-outputs-specifying-outputs",
    "content": "指定 outputs /*specifying-outputs*/"
  }, {
    "id": "指定-inputs-specifying-inputs",
    "content": "指定 inputs /*specifying-inputs*/"
  }, {
    "id": "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
    "content": "使用 $TURBO_DEFAULT$ 恢复默认设置 /*restoring-defaults-with-turbodefault*/"
  }, {
    "id": "注册根任务-registering-root-tasks",
    "content": "注册根任务 /*registering-root-tasks*/"
  }, {
    "id": "何时使用-root-tasks-when-to-use-root-tasks",
    "content": "何时使用 Root Tasks /*when-to-use-root-tasks*/"
  }, {
    "id": "高级用例-advanced-use-cases",
    "content": "高级用例 /*advanced-use-cases*/"
  }, {
    "id": "使用软件包配置-using-package-configurations",
    "content": "使用软件包配置 /*using-package-configurations*/"
  }, {
    "id": "组合配置-composing-configurations",
    "content": "组合配置 /*composing-configurations*/"
  }, {
    "id": "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
    "content": "具有运行时依赖的长时间运行任务 /*long-running-tasks-with-runtime-dependencies*/"
  }, {
    "id": "执行副作用-performing-side-effects",
    "content": "执行副作用 /*performing-side-effects*/"
  }, {
    "id": "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
    "content": "可并行运行的依赖任务 /*dependent-tasks-that-can-be-run-in-parallel*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {LinkToDocumentation} from '#components/link-to-documentation';
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Files, File, Folder} from '#components/files';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#入门-getting-started",
  title: _jsx(_Fragment, {
    children: "入门 "
  })
}, {
  depth: 2,
  url: "#定义任务-defining-tasks",
  title: _jsx(_Fragment, {
    children: "定义任务 "
  })
}, {
  depth: 3,
  url: "#按正确顺序运行任务-running-tasks-in-the-right-order",
  title: _jsx(_Fragment, {
    children: "按正确顺序运行任务 "
  })
}, {
  depth: 4,
  url: "#依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
  title: _jsxs(_Fragment, {
    children: ["依赖于 ", _jsx("code", {
      children: "^"
    }), " 依赖中的任务 "]
  })
}, {
  depth: 4,
  url: "#依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
  title: _jsx(_Fragment, {
    children: "依赖于同一包中的任务 "
  })
}, {
  depth: 4,
  url: "#依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
  title: _jsx(_Fragment, {
    children: "依赖于特定包中的特定任务 "
  })
}, {
  depth: 4,
  url: "#无依赖-no-dependencies",
  title: _jsx(_Fragment, {
    children: "无依赖 "
  })
}, {
  depth: 3,
  url: "#指定-outputs-specifying-outputs",
  title: _jsxs(_Fragment, {
    children: ["指定 ", _jsx("code", {
      children: "outputs"
    }), " "]
  })
}, {
  depth: 3,
  url: "#指定-inputs-specifying-inputs",
  title: _jsxs(_Fragment, {
    children: ["指定 ", _jsx("code", {
      children: "inputs"
    }), " "]
  })
}, {
  depth: 4,
  url: "#使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "$TURBO_DEFAULT$"
    }), " 恢复默认设置 "]
  })
}, {
  depth: 3,
  url: "#注册根任务-registering-root-tasks",
  title: _jsx(_Fragment, {
    children: "注册根任务 "
  })
}, {
  depth: 4,
  url: "#何时使用-root-tasks-when-to-use-root-tasks",
  title: _jsx(_Fragment, {
    children: "何时使用 Root Tasks "
  })
}, {
  depth: 2,
  url: "#高级用例-advanced-use-cases",
  title: _jsx(_Fragment, {
    children: "高级用例 "
  })
}, {
  depth: 3,
  url: "#使用软件包配置-using-package-configurations",
  title: _jsx(_Fragment, {
    children: "使用软件包配置 "
  })
}, {
  depth: 3,
  url: "#组合配置-composing-configurations",
  title: _jsx(_Fragment, {
    children: "组合配置 "
  })
}, {
  depth: 3,
  url: "#具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
  title: _jsx(_Fragment, {
    children: "具有运行时依赖的长时间运行任务 "
  })
}, {
  depth: 3,
  url: "#执行副作用-performing-side-effects",
  title: _jsx(_Fragment, {
    children: "执行副作用 "
  })
}, {
  depth: 3,
  url: "#可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
  title: _jsx(_Fragment, {
    children: "可并行运行的依赖任务 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["任务是 Turborepo 运行的脚本。你可以表达 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " configuration"]
      }), " 和 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 中任务之间的关系。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A task is a script that Turborepo runs. You can express relationships between tasks in your ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " configuration"]
      }), " and ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 始终会并行执行所有工作，以确保一切尽可能快地运行。这比一次运行一个任务要快，这也是 Turborepo 如此快速的原因之一。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo will always parallelize any work that it can to ensure everything runs as fast as possible. This is faster than running tasks one at a time, and it's a part of what makes Turborepo so fast."
    }), "\n", _jsxs(_components.p, {
      children: ["例如，", _jsx("code", {
        style: {
          textWrap: "wrap"
        },
        children: "yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test"
      }), " 如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For example, ", _jsx("code", {
        style: {
          textWrap: "wrap"
        },
        children: "yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test"
      }), " would look like this:"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/slow-tasks-dark.png',
        props: {
          width: 778,
          height: 331
        }
      },
      light: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/slow-tasks-light.png',
        props: {
          width: 778,
          height: 331
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["但是，为了使用 Turborepo 更快地完成相同的工作，你可以使用 ", _jsx(_components.code, {
        children: "turbo run lint build test"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥But, to get the same work done ", _jsx(_components.strong, {
        children: "faster"
      }), " with Turborepo, you can use ", _jsx(_components.code, {
        children: "turbo run lint build test"
      }), ":"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/turborepo-tasks-fast-dark.png',
        props: {
          width: 778,
          height: 448
        }
      },
      light: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/turborepo-tasks-fast-light.png',
        props: {
          width: 778,
          height: 448
        }
      }
    }), "\n", _jsx(_components.h2, {
      id: "入门-getting-started",
      children: "入门 "
    }), "\n", _jsx(_components.p, {
      children: "¥Getting started"
    }), "\n", _jsxs(_components.p, {
      children: ["根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件是注册 Turborepo 将运行的任务的地方。定义好任务后，你就可以使用 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), " 运行一个或多个任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file is where you'll register the tasks that Turborepo will run. Once you have your tasks defined, you'll be able to run one or more tasks using ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果你是新手，我们建议你使用 ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation",
            children: ["使用 ", _jsx(_components.code, {
              children: "create-turbo"
            }), " 创建新仓库"]
          }), " 并编辑 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 文件以尝试本指南中的代码片段。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If you're starting fresh, we recommend ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation",
            children: ["creating a new repository using ", _jsx(_components.code, {
              children: "create-turbo"
            })]
          }), " and editing the ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file to try out the snippets in this guide."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果你要在现有存储库中采用 Turborepo，请在存储库的根目录中创建一个 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 文件。你将使用它来了解本指南中的其余配置选项。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If you're adopting Turborepo in an existing repository, create a ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file in the root of your repository. You'll be using it to learn about the rest of the configuration options in this guide."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "turbo.json",
        green: true
      }), _jsx(File, {
        name: "package.json"
      }), _jsx(Folder, {
        name: "apps"
      }), _jsx(Folder, {
        name: "packages"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "定义任务-defining-tasks",
      children: "定义任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Defining tasks"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tasks"
      }), " 对象中的每个键都是一个可由 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 执行的任务。Turborepo 将在你的包中搜索其 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中与任务同名的脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Each key in the ", _jsx(_components.code, {
        children: "tasks"
      }), " object is a task that can be executed by ", _jsx(_components.code, {
        children: "turbo run"
      }), ". Turborepo will search your packages for ", _jsxs(_components.strong, {
        children: ["scripts in their ", _jsx(_components.code, {
          children: "package.json"
        }), " that have the same name as the task"]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["要定义任务，请在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中使用 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#tasks",
        children: [_jsx(_components.code, {
          children: "tasks"
        }), " 对象"]
      }), "。例如，一个名为 ", _jsx(_components.code, {
        children: "build"
      }), " 且没有依赖和输出的基本任务可能如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To define a task, use ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#tasks",
        children: ["the ", _jsx(_components.code, {
          children: "tasks"
        }), " object"]
      }), " in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ". For example, a basic task with no dependencies and no outputs named ", _jsx(_components.code, {
        children: "build"
      }), " might look like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {} "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Incorrect!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你此时运行 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "，Turborepo 将并行运行你软件包中的所有 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本，并且不会缓存任何文件输出。这将很快导致错误。你缺少一些重要的部分，无法使其按预期工作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you run ", _jsx(_components.code, {
        children: "turbo run build"
      }), " at this point, Turborepo will run all ", _jsx(_components.code, {
        children: "build"
      }), " scripts in your packages in parallel and won't cache any file outputs. ", _jsx(_components.strong, {
        children: "This will quickly lead to errors."
      }), " You're missing a few important pieces to make this work how you'd expect."]
    }), "\n", _jsx(_components.h3, {
      id: "按正确顺序运行任务-running-tasks-in-the-right-order",
      children: "按正确顺序运行任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Running tasks in the right order"
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: [_jsx(_components.code, {
          children: "dependsOn"
        }), " 键"]
      }), " 用于指定在其他任务开始运行之前必须完成的任务。例如，在大多数情况下，你希望库的 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本在应用的 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本运行之前完成。为此，你需要使用以下 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: ["The ", _jsx(_components.code, {
          children: "dependsOn"
        }), " key"]
      }), " is used to specify the tasks that must complete before a different task begins running. For example, in most cases, you want the ", _jsx(_components.code, {
        children: "build"
      }), " script for your libraries to complete before your application's ", _jsx(_components.code, {
        children: "build"
      }), " script runs. To do this, you'd use the following ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "现在，你已拥有预期的构建顺序，即先构建依赖，再构建依赖。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥You now have the build order you would expect, building ", _jsx(_components.em, {
        children: "dependencies"
      }), " before ", _jsx(_components.em, {
        children: "dependents"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["但要小心。目前，你尚未将构建输出标记为缓存。为此，请跳转到 ", _jsx(_components.a, {
        href: "#specifying-outputs",
        children: "指定输出"
      }), " 部分。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "But be careful."
      }), " At this point, you haven't marked the build outputs for caching. To do so, jump to the ", _jsx(_components.a, {
        href: "#specifying-outputs",
        children: "Specifying outputs"
      }), " section."]
    }), "\n", _jsxs(_components.h4, {
      id: "依赖于--依赖中的任务-depending-on-tasks-in-dependencies-with-",
      children: ["依赖于 ", _jsx(_components.code, {
        children: "^"
      }), " 依赖中的任务 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Depending on tasks in dependencies with ", _jsx(_components.code, {
        children: "^"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "^"
      }), " 微语法指示 Turborepo 在目标包之前运行直接依赖中的任务。如果你的应用依赖于名为 ", _jsx(_components.code, {
        children: "ui"
      }), " 的库，并且该库包含 ", _jsx(_components.code, {
        children: "build"
      }), " 任务，则 ", _jsx(_components.code, {
        children: "ui"
      }), " 中的 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本将首先运行。成功完成后，应用中的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务将运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "^"
      }), " microsyntax tells Turborepo to run the task in direct dependencies before the target package. If your application depends on a library named ", _jsx(_components.code, {
        children: "ui"
      }), " and the library has a ", _jsx(_components.code, {
        children: "build"
      }), " task, the ", _jsx(_components.code, {
        children: "build"
      }), " script in ", _jsx(_components.code, {
        children: "ui"
      }), " will run ", _jsx(_components.strong, {
        children: "first"
      }), ". Once it has successfully completed, the ", _jsx(_components.code, {
        children: "build"
      }), " task in your application will run."]
    }), "\n", _jsxs(_components.p, {
      children: ["这是一个重要的模式，因为它可以确保应用的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务拥有编译所需的所有必要依赖。当你的依赖图发展到具有多层任务依赖的更复杂结构时，此概念也适用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is an important pattern as it ensures that your application's ", _jsx(_components.code, {
        children: "build"
      }), " task will have all of the necessary dependencies that it needs to compile. This concept also applies as your dependency graph grows to a more complex structure with many levels of task dependencies."]
    }), "\n", _jsx(_components.h4, {
      id: "依赖于同一包中的任务-depending-on-tasks-in-the-same-package",
      children: "依赖于同一包中的任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Depending on tasks in the same package"
    }), "\n", _jsxs(_components.p, {
      children: ["有时，你可能需要确保同一个软件包中的两个任务按特定顺序运行。例如，你可能需要先在库中运行 ", _jsx(_components.code, {
        children: "build"
      }), " 任务，然后再在同一个库中运行 ", _jsx(_components.code, {
        children: "test"
      }), " 任务。为此，请将 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 键中的脚本指定为纯字符串（不带 ", _jsx(_components.code, {
        children: "^"
      }), "）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sometimes, you may need to ensure that two tasks in the same package run in a specific order. For example, you may need to run a ", _jsx(_components.code, {
        children: "build"
      }), " task in your library before running a ", _jsx(_components.code, {
        children: "test"
      }), " task in the same library. To do this, specify the script in the ", _jsx(_components.code, {
        children: "dependsOn"
      }), " key as a plain string (without the ", _jsx(_components.code, {
        children: "^"
      }), ")."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "依赖于特定包中的特定任务-depending-on-a-specific-task-in-a-specific-package",
      children: "依赖于特定包中的特定任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Depending on a specific task in a specific package"
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以指定特定包中要依赖的单个任务。在下面的示例中，", _jsx(_components.code, {
        children: "utils"
      }), " 中的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务必须在任何 ", _jsx(_components.code, {
        children: "lint"
      }), " 任务之前运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also specify an individual task in a specific package to depend on. In the example below, the ", _jsx(_components.code, {
        children: "build"
      }), " task in ", _jsx(_components.code, {
        children: "utils"
      }), " must be run before any ", _jsx(_components.code, {
        children: "lint"
      }), " tasks."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你还可以更具体地指定依赖任务，将其限制在某个软件包上："
    }), "\n", _jsx(_components.p, {
      children: "¥You can also be more specific about the dependent task, limiting it to a certain package:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["使用此配置，你的 ", _jsx(_components.code, {
        children: "web"
      }), " 包中的 ", _jsx(_components.code, {
        children: "lint"
      }), " 任务只能在 ", _jsx(_components.code, {
        children: "utils"
      }), " 包中的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务完成后运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With this configuration, the ", _jsx(_components.code, {
        children: "lint"
      }), " task in your ", _jsx(_components.code, {
        children: "web"
      }), " package can only be run after the ", _jsx(_components.code, {
        children: "build"
      }), " task in the ", _jsx(_components.code, {
        children: "utils"
      }), " package is complete."]
    }), "\n", _jsx(_components.h4, {
      id: "无依赖-no-dependencies",
      children: "无依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥No dependencies"
    }), "\n", _jsxs(_components.p, {
      children: ["某些任务可能没有任何依赖。例如，用于在 Markdown 文件中查找拼写错误的任务可能不需要关心其他任务的状态。在这种情况下，你可以省略 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 键或提供一个空数组。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Some tasks may not have any dependencies. For example, a task for finding typos in Markdown files likely doesn't need to care about the status of your other tasks. In this case, you can omit the ", _jsx(_components.code, {
        children: "dependsOn"
      }), " key or provide an empty array."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"spell-check\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "指定-outputs-specifying-outputs",
      children: ["指定 ", _jsx(_components.code, {
        children: "outputs"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specifying ", _jsx(_components.code, {
        children: "outputs"
      })]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["Turborepo 会缓存任务的输出，这样你就不会重复执行相同的工作。我们将在 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/caching",
          children: "缓存指南"
        }), " 中深入讨论这一点，但首先请确保你的任务已正确配置。"]
      }), _jsxs(_components.p, {
        children: ["¥Turborepo caches the outputs of your tasks so that you never do the same work\ntwice. We'll discuss this in depth in ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/caching",
          children: "the Caching\nguide"
        }), ", but let's make sure your tasks\nare properly configured first."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " 键告知 Turborepo 在任务成功完成后应缓存的文件和目录。如果没有定义此键，Turborepo 将不会缓存任何文件。后续运行时命中缓存不会恢复任何文件输出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "outputs"
      }), " key tells Turborepo ", _jsx(_components.strong, {
        children: "files and directories"
      }), " it should cache when the task has successfully completed. ", _jsx(_components.strong, {
        children: "Without this key defined, Turborepo will not cache any files. Hitting cache on subsequent runs will not restore any file outputs."
      })]
    }), "\n", _jsx(_components.p, {
      children: "以下是一些常用工具的输出示例："
    }), "\n", _jsx(_components.p, {
      children: "¥Below are a few examples of outputs for common tools:"
    }), "\n", _jsxs(Tabs, {
      items: ["Next.js", "Vite", "tsc"],
      storageKey: "outputs-tools",
      children: [_jsx(Tab, {
        value: "Next.js",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Vite",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "tsc",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Globs 是相对于包的，因此 ", _jsx(_components.code, {
        children: "dist/**"
      }), " 将分别处理每个包输出的 ", _jsx(_components.code, {
        children: "dist"
      }), "。关于如何为 ", _jsx(_components.code, {
        children: "outputs"
      }), " 键构建通配符模式的更多信息，请参阅 ", _jsx(_components.a, {
        href: "/docs/reference/globs",
        children: "通配符规范"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Globs are relative to the package, so ", _jsx(_components.code, {
        children: "dist/**"
      }), " will handle the ", _jsx(_components.code, {
        children: "dist"
      }), " that is outputted for each package, respectively. For more on building globbing patterns for the ", _jsx(_components.code, {
        children: "outputs"
      }), " key, see ", _jsx(_components.a, {
        href: "/docs/reference/globs",
        children: "the globbing specification"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "指定-inputs-specifying-inputs",
      children: ["指定 ", _jsx(_components.code, {
        children: "inputs"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specifying ", _jsx(_components.code, {
        children: "inputs"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "inputs"
      }), " 键用于指定要包含在 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " 任务哈希值中的文件。默认情况下，Turborepo 将包含包中所有由 Git 跟踪的文件。但是，你可以使用 ", _jsx(_components.code, {
        children: "inputs"
      }), " 键更具体地指定哈希中包含哪些文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "inputs"
      }), " key is used to specify the files that you want to include in the task's hash for ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), ". By default, Turborepo will include all files in the package that are tracked by Git. However, you can be more specific about which files are included in the hash using the ", _jsx(_components.code, {
        children: "inputs"
      }), " key."]
    }), "\n", _jsx(_components.p, {
      children: "例如，一个用于查找 Markdown 文件中拼写错误的任务可以这样定义："
    }), "\n", _jsx(_components.p, {
      children: "¥As an example, a task for finding typos in Markdown files could be defined like this:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"spell-check\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"**/*.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"**/*.mdx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["现在，只有 Markdown 文件中的更改才会导致 ", _jsx(_components.code, {
        children: "spell-check"
      }), " 任务丢失缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now, ", _jsx(_components.strong, {
        children: "only"
      }), " changes in Markdown files will cause the ", _jsx(_components.code, {
        children: "spell-check"
      }), " task to miss cache."]
    }), "\n", _jsxs(Callout, {
      type: "error",
      children: [_jsxs(_components.p, {
        children: ["此功能会退出 Turborepo 的所有默认 ", _jsx(_components.code, {
          children: "inputs"
        }), " 行为，包括跟随源代码管理跟踪的更改。这意味着你的 ", _jsx(_components.code, {
          children: ".gitignore"
        }), " 文件将不再被遵守，你需要确保不要用 glob 捕获这些文件。"]
      }), _jsxs(_components.p, {
        children: ["¥This feature opts out of all of Turborepo's default ", _jsx(_components.code, {
          children: "inputs"
        }), " behavior, including following along with changes tracked by source control. This means that your ", _jsx(_components.code, {
          children: ".gitignore"
        }), " file will no longer be respected, and you will need to ensure that you do not capture those files with your globs."]
      }), _jsxs(_components.p, {
        children: ["要恢复默认行为，请使用 ", _jsxs(_components.a, {
          href: "#restoring-defaults-with-turbo_default",
          children: [_jsx(_components.code, {
            children: "$TURBO_DEFAULT$"
          }), " 微语法"]
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥To restore the default behavior, use ", _jsxs(_components.a, {
          href: "#restoring-defaults-with-turbo_default",
          children: ["the ", _jsx(_components.code, {
            children: "$TURBO_DEFAULT$"
          }), " microsyntax"]
        }), "."]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "使用-turbo_default-恢复默认设置-restoring-defaults-with-turbodefault",
      children: ["使用 ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " 恢复默认设置 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Restoring defaults with ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: [_jsx(_components.code, {
          children: "inputs"
        }), " 的默认行为"]
      }), " 通常是你执行任务时所需要的。但是，你可以通过微调 ", _jsx(_components.code, {
        children: "inputs"
      }), " 键来忽略已知不会影响任务输出的文件更改，从而提高某些任务的缓存命中率。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: ["The default ", _jsx(_components.code, {
          children: "inputs"
        }), " behavior"]
      }), " is often what you will want for your tasks. However, you can increase your cache hit ratios for certain tasks by fine-tuning your ", _jsx(_components.code, {
        children: "inputs"
      }), " to ignore changes to files that are known to not affect the task's output."]
    }), "\n", _jsxs(_components.p, {
      children: ["因此，你可以使用 ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " 微语法来微调默认的 ", _jsx(_components.code, {
        children: "inputs"
      }), " 行为："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For this reason, you can use the ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " microsyntax to fine-tune the default ", _jsx(_components.code, {
        children: "inputs"
      }), " behavior:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!README.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在此任务定义中，Turborepo 将对 ", _jsx(_components.code, {
        children: "build"
      }), " 任务使用默认的 ", _jsx(_components.code, {
        children: "inputs"
      }), " 行为，但会忽略对 ", _jsx(_components.code, {
        children: "README.md"
      }), " 文件的更改。如果 ", _jsx(_components.code, {
        children: "README.md"
      }), " 文件发生更改，任务仍会命中缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In this task definition, Turborepo will use the default ", _jsx(_components.code, {
        children: "inputs"
      }), " behavior for the ", _jsx(_components.code, {
        children: "build"
      }), " task, but will ignore changes to the ", _jsx(_components.code, {
        children: "README.md"
      }), " file. If the ", _jsx(_components.code, {
        children: "README.md"
      }), " file is changed, the task will still hit cache."]
    }), "\n", _jsx(_components.h3, {
      id: "注册根任务-registering-root-tasks",
      children: "注册根任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Registering Root Tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以使用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 在工作区根目录下的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中运行脚本。例如，除了每个包中的 ", _jsx(_components.code, {
        children: "lint"
      }), " 任务之外，你可能还想为工作区根目录中的文件运行 ", _jsx(_components.code, {
        children: "lint:root"
      }), " 任务："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also run scripts in the ", _jsx(_components.code, {
        children: "package.json"
      }), " in the Workspace root using ", _jsx(_components.code, {
        children: "turbo"
      }), ". For example, you may want to run a ", _jsx(_components.code, {
        children: "lint:root"
      }), " task for the files in your Workspace's root directory in addition to the ", _jsx(_components.code, {
        children: "lint"
      }), " task in each package:"]
    }), "\n", _jsxs(Tabs, {
      items: ["turbo.json", "package.json"],
      children: [_jsx(Tab, {
        value: "turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"//#lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {} "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "package.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["根任务现已注册，", _jsx(_components.code, {
        children: "turbo run lint:root"
      }), " 现在将运行该任务。你还可以运行 ", _jsx(_components.code, {
        children: "turbo run lint lint:root"
      }), " 来运行所有 linting 任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With the Root Task now registered, ", _jsx(_components.code, {
        children: "turbo run lint:root"
      }), " will now run the task. You can also run ", _jsx(_components.code, {
        children: "turbo run lint lint:root"
      }), " to run all your linting tasks."]
    }), "\n", _jsx(_components.h4, {
      id: "何时使用-root-tasks-when-to-use-root-tasks",
      children: "何时使用 Root Tasks "
    }), "\n", _jsx(_components.p, {
      children: "¥When to use Root Tasks"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "工作区根目录的 Linting 和格式化：你的工作区根目录中可能有需要进行 lint 和格式化的代码。例如，你可能想在根目录中运行 ESLint 或 Prettier。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Linting and formatting of the Workspace root"
          }), ": You might have code in your Workspace root that you want to lint and format. For example, you might want to run ESLint or Prettier in your root directory."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "增量迁移：在迁移到 Turborepo 时，你可能有一个中间步骤，其中有一些脚本尚未移动到包中。在这种情况下，你可以创建一个根任务来开始迁移，并稍后将任务分散到各个包。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Incremental migration"
          }), ": While you're migrating to Turborepo, you might have an in-between step where you have some scripts that you haven't moved to packages yet. In this case, you can create a Root Task to start migrating and fan the tasks out to packages later."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["不属于包范围的脚本：你可能有一些脚本在特定包的上下文中没有意义。这些脚本可以注册为根任务，因此你仍然可以使用 ", _jsx(_components.code, {
            children: "turbo"
          }), " 运行它们，以实现缓存、并行化和工作流目的。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Scripts without a package scope"
          }), ": You may have some scripts that don't make sense in the context of specific packages. Those scripts can be registered as Root Tasks so you can still run them with ", _jsx(_components.code, {
            children: "turbo"
          }), " for caching, parallelization, and workflow purposes."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "高级用例-advanced-use-cases",
      children: "高级用例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Advanced use cases"
    }), "\n", _jsx(_components.h3, {
      id: "使用软件包配置-using-package-configurations",
      children: "使用软件包配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using Package Configurations"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 是直接放置在包中的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件。这允许包为其自身任务定义特定行为，而不会影响仓库的其余部分。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), " are ", _jsx(_components.code, {
        children: "turbo.json"
      }), " files that are placed directly into a package. This allows a package to define specific behavior for its own tasks without affecting the rest of the repository."]
    }), "\n", _jsxs(_components.p, {
      children: ["在拥有多个团队的大型单体仓库中，这可以让团队更好地控制自己的任务。要了解更多信息，请访问 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "包配置文档"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In large monorepos with many teams, this allows teams greater control over their own tasks. To learn more, visit ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "the Package Configurations documentation"
      })]
    }), "\n", _jsx(_components.h3, {
      id: "组合配置-composing-configurations",
      children: "组合配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Composing configurations"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 可以组合使用，以便在更少的配置下实现更强大的控制："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), " can be composed for greater control with less configuration:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/reference/package-configurations#extending-from-other-packages",
            children: _jsx(_components.strong, {
              children: "从其他包扩展"
            })
          }), "：创建多个包可以继承的共享配置包，从而启用共享的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 配置。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/package-configurations#extending-from-other-packages",
            children: _jsx(_components.strong, {
              children: "Extending from other packages"
            })
          }), ": Create shared configuration packages that multiple packages can extend from, enabling shared ", _jsx(_components.code, {
            children: "turbo.json"
          }), " configurations."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/reference/package-configurations#extending-arrays-with-turbo_extends",
            children: _jsx(_components.strong, {
              children: "添加到扩展配置"
            })
          }), "：使用 ", _jsx(_components.code, {
            children: "$TURBO_EXTENDS$"
          }), " 微语法向继承的数组值（例如 ", _jsx(_components.code, {
            children: "outputs"
          }), " 和 ", _jsx(_components.code, {
            children: "env"
          }), "）添加内容而不是替换它们。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/package-configurations#extending-arrays-with-turbo_extends",
            children: _jsx(_components.strong, {
              children: "Adding to extended configurations"
            })
          }), ": Use the ", _jsx(_components.code, {
            children: "$TURBO_EXTENDS$"
          }), " microsyntax to add to inherited array values like ", _jsx(_components.code, {
            children: "outputs"
          }), " and ", _jsx(_components.code, {
            children: "env"
          }), " instead of replacing them."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "具有运行时依赖的长时间运行任务-long-running-tasks-with-runtime-dependencies",
      children: "具有运行时依赖的长时间运行任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Long-running tasks with runtime dependencies"
    }), "\n", _jsxs(_components.p, {
      children: ["你可能有一个长时间运行的任务，需要另一个任务始终同时运行。为此，请使用 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#with",
        children: [_jsx(_components.code, {
          children: "with"
        }), " 键"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You might have a long-running task that requires another task to always be running at the same time. For this, use ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#with",
        children: ["the ", _jsx(_components.code, {
          children: "with"
        }), " key"]
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"with\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"api#dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["长时间运行的任务永远不会退出，这意味着你不能依赖它。相反，每当 ", _jsx(_components.code, {
        children: "web#dev"
      }), " 任务运行时，", _jsx(_components.code, {
        children: "with"
      }), " 关键字都会运行 ", _jsx(_components.code, {
        children: "api#dev"
      }), " 任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A long-running task never exits, meaning you can't depend on it. Instead, the ", _jsx(_components.code, {
        children: "with"
      }), " keyword will run the ", _jsx(_components.code, {
        children: "api#dev"
      }), " task whenever the ", _jsx(_components.code, {
        children: "web#dev"
      }), " task runs."]
    }), "\n", _jsx(_components.h3, {
      id: "执行副作用-performing-side-effects",
      children: "执行副作用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Performing side-effects"
    }), "\n", _jsxs(_components.p, {
      children: ["某些任务无论如何都应该始终运行，例如缓存构建后的部署脚本。对于这些任务，请将 ", _jsx(_components.code, {
        children: "\"cache\": false"
      }), " 添加到你的任务定义中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Some tasks should always be run no matter what, like a deployment script after a cached build. For these tasks, add ", _jsx(_components.code, {
        children: "\"cache\": false"
      }), " to your task definition."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"deploy\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "可并行运行的依赖任务-dependent-tasks-that-can-be-run-in-parallel",
      children: "可并行运行的依赖任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Dependent tasks that can be run in parallel"
    }), "\n", _jsx(_components.p, {
      children: "某些任务可以并行运行，尽管它们依赖于其他软件包。类型检查器就是符合此描述的任务示例，因为类型检查器无需等待依赖的输出即可成功运行。"
    }), "\n", _jsx(_components.p, {
      children: "¥Some tasks can be run in parallel despite being dependent on other packages. An example of tasks that fit this description are type checkers, since a type checker doesn't need to wait for outputs in dependencies to run successfully."
    }), "\n", _jsxs(_components.p, {
      children: ["因此，你可能倾向于像这样定义你的 ", _jsx(_components.code, {
        children: "check-types"
      }), " 任务："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because of this, you may be tempted to define your ", _jsx(_components.code, {
        children: "check-types"
      }), " task like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {} "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Incorrect!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "这会并行运行你的任务 - 但它不考虑依赖中的源代码更改。这意味着你可以："
    }), "\n", _jsx(_components.p, {
      children: "¥This runs your tasks in parallel - but doesn't account for source code changes in dependencies. This means you can:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["对你的 ", _jsx(_components.code, {
            children: "ui"
          }), " 软件包的界面进行重大更改。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Make a breaking change to the interface of your ", _jsx(_components.code, {
            children: "ui"
          }), " package."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["运行 ", _jsx(_components.code, {
            children: "turbo check-types"
          }), "，在依赖于 ", _jsx(_components.code, {
            children: "ui"
          }), " 的应用包中命中缓存。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Run ", _jsx(_components.code, {
            children: "turbo check-types"
          }), ", hitting cache in an application package that depends on ", _jsx(_components.code, {
            children: "ui"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "这是不正确的，因为尽管应用包未更新以使用新接口，但它仍会显示成功的缓存命中。在编辑器中手动检查应用包中的 TypeScript 错误可能会发现错误。"
    }), "\n", _jsx(_components.p, {
      children: "¥This is incorrect, since the application package will show a successful cache hit, despite not being updated to use the new interface. Checking for TypeScript errors in your application package manually in your editor is likely to reveal errors."
    }), "\n", _jsxs(_components.p, {
      children: ["因此，你需要对 ", _jsx(_components.code, {
        children: "check-types"
      }), " 任务定义进行一些小改动："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because of this, you make a small change to your ", _jsx(_components.code, {
        children: "check-types"
      }), " task definition:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// This works...but could be faster!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你再次测试在 ", _jsx(_components.code, {
        children: "ui"
      }), " 软件包中进行重大更改，你会注意到缓存行为现在是正确的。但是，任务不再并行运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you test out making breaking changes in your ", _jsx(_components.code, {
        children: "ui"
      }), " package again, you'll notice that the caching behavior is now correct. However, tasks are no longer running in parallel."]
    }), "\n", _jsxs(_components.p, {
      children: ["为了同时满足这两个要求（正确性和并行性），你可以将 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#transit-nodes",
        children: "传输节点"
      }), " 引入到你的任务图中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To meet both requirements (correctness and parallelism), you can introduce ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#transit-nodes",
        children: "Transit Nodes"
      }), " to your Task Graph:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这些 Transit 节点使用一个不执行任何操作的任务在包依赖之间建立关系，因为它与任何 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的脚本都不匹配。因此，你的任务可以并行运行，并能够感知其内部依赖的变化。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥These Transit Nodes create a relationship between your package dependencies using a task that doesn't do anything because it doesn't match a script in any ", _jsx(_components.code, {
        children: "package.json"
      }), "s. Because of this, your tasks can run in parallel ", _jsx(_components.strong, {
        children: "and"
      }), " be aware of changes to their internal dependencies."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["在此示例中，我们使用了名称 ", _jsx(_components.code, {
          children: "transit"
        }), " - 但你可以将任务命名为工作区中尚未包含脚本的任何名称。"]
      }), _jsxs(_components.p, {
        children: ["¥In this example, we used the name ", _jsx(_components.code, {
          children: "transit"
        }), " - but you can name the task\nanything that isn't already a script in your Workspace."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: ["配置 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 文档"]
      }), " 中还有更多选项，你将在接下来的指南中探索。现在，你可以开始运行一些任务来了解基本工作原理。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There are more options available in ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: ["the Configuring ", _jsx(_components.code, {
          children: "turbo.json"
        }), " documentation"]
      }), " that you will explore in the coming guides. For now, you can start running a few tasks to see how the basics work."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
